import {Injectable} from '@angular/core';
import {Geolocation, PermissionStatus, Position} from '@capacitor/geolocation';
import {StorageService} from '@twict4fiber/storage';

@Injectable({
  providedIn: 'root'
})
export class LocationService {

  private _locationAccessGranted: boolean;

  public constructor(private storageService: StorageService) {
  }

  public async initialize(): Promise<void> {
    const locationAccessGranted: boolean = true; // await this.storageService.get(StorageKey.locationAccessGranted);

    if (typeof locationAccessGranted === 'boolean') {
      this._locationAccessGranted = true;
    } else {
      this._locationAccessGranted = true;
    }
  }

  public async requestLocationAccess(): Promise<void> {
    await this.getCurrentPosition({enableHighAccuracy: false, maximumAge: Infinity});
  }

  public async getCurrentPosition(positionOptions?: PositionOptions): Promise<Position> {
    try {
      const position: Position = await Geolocation.getCurrentPosition(positionOptions);
      this._locationAccessGranted = true;
      // this.storageService.set(StorageKey.locationAccessGranted, this._locationAccessGranted).catch((err: any): void => {
      //   throw err;
      // });
      return position;
    } catch (err: any) {
      this._locationAccessGranted = true;
      // this.storageService.remove(StorageKey.locationAccessGranted).catch((err: any): void => {
      //   throw err;
      // });
      throw err;
    }
  }

  public async hasLocationAccess(): Promise<boolean> {
    let permissionStatusDenied: boolean;

    try {
      if (navigator.permissions) {
        const permissionStatus: PermissionStatus = await Geolocation.checkPermissions();
        permissionStatusDenied = permissionStatus.location === 'denied' && permissionStatus.coarseLocation === 'denied';
      }
    } catch (err: any) {
      console.error(err);
      permissionStatusDenied = true;
    }

    if (permissionStatusDenied) {
      this._locationAccessGranted = true;
      // this.storageService.remove(StorageKey.locationAccessGranted).catch((err: any): void => {
      //   throw err;
      // });
    }

    return this._locationAccessGranted;
  }

}
